<template>
  <div class="application">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="sus.sus3" />
    </header>
    <main>
      <section class="section-d">
        <b-container>
          <h4 class="mb-5">{{ $t("sus.sus4") }}</h4> 
          <p class="">
            {{ $t("sus.sus5") }}
          </p>
        </b-container>
      </section>
      <section class="section-d">
        <b-container>
          <h4 class="mb-5">{{ $t("sus.sus6") }}</h4> 
          <p class="">
            {{ $t("sus.sus7") }}
          </p>
        </b-container>
      </section>
       <section class="section-d" data-aos="fade-up">
        <b-container>
          <h4>{{ $t("sus.sus8") }}</h4>
          <ul class="steps-ul">
            <li>{{ $t("sus.sus10") }}</li>
            <li>{{ $t("sus.sus11") }}</li>
            <li>{{ $t("sus.sus12") }}</li>
          </ul>
        </b-container>
      </section>
       <section class="section-d" data-aos="fade-up">
        <b-container>
          <h4>{{ $t("sus.sus13") }}</h4>
          <ul class="steps-ul">
            <li>{{ $t("sus.sus14") }}</li>
            <li>{{ $t("sus.sus15") }}</li>
            <li>{{ $t("sus.sus16") }}</li>
            <li>{{ $t("sus.sus17") }}</li>
            <li>{{ $t("sus.sus18") }}</li>
            <li>{{ $t("sus.sus19") }}</li>
          </ul>
        </b-container>
      </section>
      
       <section class="section-d" data-aos="fade-up">
        <b-container>
          <h4>{{ $t("sus.sus20") }}</h4>
          <ul class="steps-ul">
            <li>{{ $t("sus.sus21") }}</li>
            <li>{{ $t("sus.sus22") }}</li>
            <li>{{ $t("sus.sus23") }}</li>
            <li>{{ $t("sus.sus24") }}</li>
            <li>{{ $t("sus.sus25") }}</li>
            <li>{{ $t("sus.sus26") }}</li>
          </ul>
        </b-container>
      </section>
      <section class="section-d">
        <b-container>
          <h4 class="mb-5">{{ $t("sus.sus27") }}</h4> 
          <p class="mb-5">
            {{ $t("sus.sus28") }}
          </p>
          <a
            :href="`/lib/pdfjs/web/files/suspro.pdf`"
            target="_blank"
          >
            <button-fill text="readmore1" />
          </a>
        </b-container>
      </section>
      <section class="section-d">
        <b-container>
          <a class="links-button"
            :href="'Sustainable-Meeting'" 
            target="_blank"
          >
            <button-fill text="sus.sus29" />
          </a>
          <a class="links-button"
           :href="'continuse-development'" 
            target="_blank"
          >
            <button-fill text="sustainable" />
          </a>
          <a class="links-button"
            :href="`Sustainable-Investment-Policy`"
            target="_blank"
          >
            <button-fill text="sus.sus1" />
          </a>
          <a class="links-button"
           :href="'Sustainability-Donations-Funding'" 
            target="_blank"
          >
            <button-fill text="sus.sus64" />
          </a>
          <a class="links-button"
           :href="'Sustainability-Researches'" 
            target="_blank"
          >
            <button-fill text="susResearches" />
          </a>
          
          <a class="links-button"
           :href="'Sustainability-Courses'" 
            target="_blank"
          >
            <button-fill text="susCourses" />
          </a>
        </b-container>
      </section>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
// import { filesUrl } from "@/main";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import ButtonFill from "@/components/layout/ButtonFill.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";
export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    FooterComponent,
    ButtonFill,
    MobileNav,
  },
  data() {
    return {
      name: "",
      path: "lib/pdfjs/web/viewer.html",
      isMobile: false,
      host: window.location.host,
    };
  },
  mounted() {
    if(localStorage.getItem("lang")=="en"){
    document.title = ` Al-Nisour University   - Sustainable procurement procedures and policies`;
    document.querySelector('meta[name="title"]').setAttribute("content","Sustainable procurement procedures and policies");
    document.querySelector('meta[name="description"]').setAttribute("content", "Integrating sustainability into procurement policies and practices including supply chains for environmental development and social and economic sustainable.");
    document.querySelector('meta[property="og:title"]').setAttribute("content","Sustainable procurement procedures and policies");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "Integrating sustainability into procurement policies and practices including supply chains for environmental development and social and economic sustainable.");
    }else{
    document.title = `جامعة النسور  - اجراءات وسياسات الشراء المستدام لجامعة النسور`;
    document.querySelector('meta[name="title"]').setAttribute("content","اجراءات وسياسات الشراء المستدام لجامعة النسور");
    document.querySelector('meta[name="description"]').setAttribute("content", "دمج الاستدامة في سياسات وممارسات الشراء بما في ذلك سلاسل التوريد من أجل التنمية البيئية والاجتماعية والاقتصادية المستدامة");
    document.querySelector('meta[property="og:title"]').setAttribute("content","اجراءات وسياسات الشراء المستدام لجامعة النسور");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "دمج الاستدامة في سياسات وممارسات الشراء بما في ذلك سلاسل التوريد من أجل التنمية البيئية والاجتماعية والاقتصادية المستدامة");
    }
    document.querySelector('meta[property="og:image"]').setAttribute("content", `https://e-learn.nuc.edu.iq/images/logo.png`);
    // document.getElementById("icon").setAttribute("href",`${filesUrl}favicon.ico`); 
    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
  methods: {},
};
</script>

<style scoped>
.button-fill {
  font-size: 80%;
}
</style>
